import $ from 'jquery';

class AnchorNav {
  constructor() {
    this.header = $('.js-header');
    this.anchorNavColumns = $(
      '.wp-block-column.has-anchor-nav, .js-library-posts',
    );

    if (!this.anchorNavColumns.length) {
      return;
    }

    this.loaded = false;
    this.headingAnchors = 'h1[id],h2[id],h3[id],h4[id],h5[id],h6[id]';

    $(window).on('load', () => {
      this.scrollable();
    });

    $(window).on('scroll', () => {
      this.scrollable();
    });
  }

  scrollable() {
    this.scrollTopPos = $(window).scrollTop();

    $.each(this.anchorNavColumns, (i, el) => {
      const column = $(el);
      const container = column.parent();
      let anchorNavColumn = container
        .find('.wp-block-column.has-anchor-nav')
        .first(); // to make sure only one nav is used per columns block
      let contentColumn = container
        .find('.wp-block-column')
        .not('.has-anchor-nav')
        .first();

      if (!anchorNavColumn.length) {
        anchorNavColumn = column.find('.js-library-posts-nav');
      }

      if (!contentColumn.length) {
        contentColumn = column.find('.js-library-posts-content');
      }

      if (anchorNavColumn.length && contentColumn.length) {
        if (!this.loaded) {
          if (!anchorNavColumn.find('.c-anchor-nav.js-anchor-nav').length) {
            anchorNavColumn.wrapInner(
              '<div class="c-anchor-nav js-anchor-nav"></div>',
            );
          }

          this.anchorSmoothScroll(anchorNavColumn, contentColumn);
          this.loaded = true;
        }

        const anchorNav = anchorNavColumn.find('.js-anchor-nav');

        if (anchorNav.length) {
          const contentColumnHeight = contentColumn.outerHeight();
          const anchorNavColumnHeight = anchorNavColumn.outerHeight();
          const anchorNavHeight = anchorNav.outerHeight();

          if (contentColumnHeight > anchorNavHeight) {
            anchorNav.addClass('is-sticky');
            contentColumn.addClass('is-anchor-nav-content');
            const maxTopOffset = anchorNavColumnHeight - anchorNavHeight;
            const startPosition = anchorNavColumn.offset().top;
            const positionTop = this.scrollTopPos - startPosition;

            const headerHeight = this.header.outerHeight() + 15;

            if (this.scrollTopPos > startPosition - headerHeight) {
              let topPos = positionTop + headerHeight;

              if (positionTop >= maxTopOffset) {
                topPos = maxTopOffset - 15;
              }

              if (topPos < 0) {
                topPos = 0;
              }

              anchorNav.css({
                top: topPos,
              });
            } else {
              anchorNav.css({
                top: 0,
              });
            }
          }
        }
      }
    });
  }

  anchorSmoothScroll(anchorNavColumn, contentColumn) {
    const anchorNav = anchorNavColumn.find('.js-anchor-nav');
    const anchorNavItems = anchorNav.find('li');
    const anchorContentHeaders = contentColumn.find(this.headingAnchors);

    if (anchorNavItems.length) {
      anchorNavItems.first().addClass('is-active');
    }

    if (anchorContentHeaders.length) {
      anchorContentHeaders.first().addClass('is-active');
      anchorContentHeaders
        .first()
        .nextUntil(this.headingAnchors)
        .addClass('is-active');
    }

    anchorNav.on('click', 'a', e => {
      const link = $(e.currentTarget);
      const href = link.attr('href');

      if (href.substr(0, 1) === '#') {
        e.preventDefault();
        const anchor = contentColumn.find(href);

        if (anchor.length) {
          $('body, html')
            .stop()
            .animate(
              {
                scrollTop: anchor.offset().top - 20 - this.header.outerHeight(),
              },
              300,
            );
        }
      }
    });

    this.setActiveClasses(anchorContentHeaders, contentColumn, anchorNav);

    $(window).on('scroll', () => {
      this.setActiveClasses(anchorContentHeaders, contentColumn, anchorNav);
    });
  }

  setActiveClasses(anchorContentHeaders, contentColumn, anchorNav) {
    // const anchorContentHeadersPositions = anchorContentHeaders
    //   .map((i, el) => ({
    //     header: $(el),
    //     position: $(el).offset().top,
    //   }))
    //   .get();

    $.each(anchorContentHeaders, (i, el) => {
      const header = $(el);
      const position = header.offset().top;
      const headerHeight = this.header.outerHeight();

      if (
        position > this.scrollTopPos - headerHeight &&
        position - this.scrollTopPos - headerHeight <= 30
      ) {
        contentColumn.find('.is-active').removeClass('is-active');
        anchorNav.find('.is-active').removeClass('is-active');
        header.addClass('is-active');
        header.nextUntil(this.headingAnchors).addClass('is-active');

        const anchorLink = anchorNav.find(`a[href="#${header.attr('id')}"]`);

        if (anchorLink.length) {
          anchorLink.parent().addClass('is-active');
        }
        return false;
      }

      return true;
    });
  }
}

export default new AnchorNav();



// WEBPACK FOOTER //
// ./src/scripts/modules/anchor-nav.js